import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ProjectReferenceSearchResponse} from '../../models/project-reference-search-response';

@Component({
    selector: 'app-project-reference-carousel-page',
    templateUrl: './project-reference-carousel-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectReferenceCarouselPageComponent {
    @Input() dark = false;
    @Input() references: ProjectReferenceSearchResponse[] = [];
}
